export default __webpack_public_path__ + "static/media/cookies.6a114252.png";